import { action } from 'lib/actionHelpers';
import setQuery from 'lib/setQuery.js';
import { publishAction } from 'redux/actions/messagesActions';

const closeModalQueryStringKeys = [
  'modal',
  'view',
  'lead',
  'filter',
  'reply',
  'eid',
  'tid',
  'type', //
  'template',
  'tab',
  'pipelineLeadId',
  'statusId',
  'contact',
  'noteId',
  'creating',
  'event_type',
  'etype',
  'todoId',
  'integrationAction',
  'bai',
  'apli',
];

export const closeLeadModal = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const viewingRecordData = {
    event: 'viewing_record',
    key: `viewing_record`,
    message: { id: params['l'] ? params['l'] : params['ei'], clear: true, initials: '' },
  };
  publishAction({ data: viewingRecordData });
  const values = Object.fromEntries(new Map(closeModalQueryStringKeys.map((n) => [n, null])));
  setQuery(values, true);
  action('RESET_COMPOSER_PHONE');
  action('leadModalSetMetaMessageUniqueId', null);
};
